import React from 'react'
import Sidebar from '../../Components/sideBar'

function CandidateDatabase() {
  return (
    <h1>
      Candidate Database
    </h1>
  )
}

export default CandidateDatabase
